import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Icons } from '../../../../shared/helpers/icons';
import { IContact } from '../../../../shared/models/contact';
import { IBasicResource } from '../../../../shared/models/basicResource';
import { UserDataService } from '../../../../shared/services/userData.service';
import { ContactsService } from '../../../../shared/services/contact.service';
import { BasicResourcesService } from '../../../../shared/services/basicResource.service';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';

@Component({
  selector: 'edit-resource',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule,
    FormsModule,
    SpinnerComponent
  ],
  templateUrl: './edit-resource.component.html',
  styleUrl: './edit-resource.component.css'
})
export class EditResourceComponent implements OnInit {
  icons = Icons;
  currentBuildingId: string | null = null;
  fullContactsList: IContact[] = [];
  contactsList: IContact[] = [];

  @Input() resourceToEdit: IBasicResource | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  resourceData: IBasicResource = {
    resources: '',
    contact_id: 0,
    location: '',
    resource_group: 'Tools'
  };

  suggestions: string[] = [
    'Local Emergency Management Agency',
    'Local Hospital',
    'Local School (Nurse)',
    'Mental Health',
    'Public Health',
    'Local School'
  ];

  loading: boolean = false;
  showSuggestions: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private contactsService: ContactsService,
    private basicResourcesService: BasicResourcesService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.loadContacts();
  }

  // ✅ react to changes in the input
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resourceToEdit'] && this.resourceToEdit) {
      this.resourceData = {
        resources: this.resourceToEdit.resources || '',
        contact_id: this.resourceToEdit.contact_id || 0,
        location: this.resourceToEdit.location || '',
        resource_group: this.resourceToEdit.resource_group || 'Tools'
      };
    }
  }

  loadContacts(): void {
    this.loading = true;
    this.contactsService.getContacts(this.currentBuildingId!).subscribe({
      next: (response) => {
        this.loading = false;
        this.fullContactsList = response.data || [];
        this.contactsList = [...this.fullContactsList].sort((a, b) => a.name.localeCompare(b.name));

        // if no contact set in resource, default to first
        if (!this.resourceData.contact_id && this.contactsList.length > 0) {
          this.resourceData.contact_id = this.contactsList[0].id;
        }
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error loading contacts:', error.message);
      }
    });
  }

  get filteredSuggestions(): string[] {
    const query = this.resourceData.location?.toLowerCase() || '';
    return this.suggestions.filter(s => s.toLowerCase().includes(query));
  }

  selectSuggestion(value: string): void {
    this.resourceData.location = value;
    this.showSuggestions = false;
  }

  hideSuggestions(): void {
    setTimeout(() => this.showSuggestions = false, 150);
  }

  closeModal(): void {
    this.onClose.emit();
  }

  saveEdit(): void {
    if (this.resourceToEdit && this.resourceToEdit.id && this.currentBuildingId) {
      this.loading = true;
      console.log("Submitting edited resource:", this.resourceData);

      this.basicResourcesService.updateBasicResource(this.currentBuildingId, String(this.resourceToEdit.id), this.resourceData).subscribe({
        next: (res) => {
          this.loading = false;
          if (!res.has_error) {
            this.onSave.emit({ type: 'success', message: 'This occurred after updating a material', data: res.data });
            this.closeModal();
          }
        },
        error: (err) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: err.message });
        }
      });
    }
  }

}
